/* tslint:disable */
import { Injectable } from '@angular/core';
import * as FileSaver from 'file-saver';
import * as XLSX from 'xlsx';

const EXCEL_TYPE = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
const EXCEL_EXTENSION = '.xlsx';

@Injectable()
export class ExportExcelService {

  constructor() { }

  public exportAsExcelFile(json: any[], excelFileName: string): void {
    const data = json;
    const header = Object.keys(data[0] || {});
    const worksheet: XLSX.WorkSheet = XLSX.utils.json_to_sheet(data);

    // Auto ajuste de colunas
    const autoWidth = data.map(row =>
      header.map(key => row[key] ? row[key].toString().length : 0)
    );

    autoWidth.push(header.map(h => h.length));
    const colWidths = header.map((_, i) => {
      const col = autoWidth.map(row => row[i]);
      return { wch: Math.max(...col) + 1};
    });

    worksheet['!cols'] = colWidths;
    const workbook: XLSX.WorkBook = { Sheets: { 'data': worksheet }, SheetNames: ['data'] };
    const excelBuffer: any = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });
    this.saveAsExcelFile(excelBuffer, excelFileName);
  }

  private saveAsExcelFile(buffer: any, fileName: string): void {
    const data: Blob = new Blob([buffer], { type: EXCEL_TYPE });
    FileSaver.saveAs(data, fileName + EXCEL_EXTENSION);
  }
}
